import React from 'react';
import styled from 'styled-components';
import IconRotateCounterClockwise from './IconRotateCounterClockwise';
var StyledIconRotateClockwise = /*#__PURE__*/styled(IconRotateCounterClockwise).withConfig({
  displayName: "StyledIconRotateClockwise",
  componentId: "c11n-8-99-3__sc-14h2ajz-0"
})(["transform:scaleX(-1);"]);
var IconRotateClockwise = function IconRotateClockwise(props) {
  return /*#__PURE__*/React.createElement(StyledIconRotateClockwise, props);
};
export default IconRotateClockwise;